import { CryptoHelper } from "../encription/encription";
import { normalizeToApiError } from "./error.service";
import { interceptorFetch } from "./interceptor.service";

const BASE_URL = `${process.env.REACT_APP_VEEP_API}`;

export async function login(email: string, password: string): Promise<any> {
    try {
        const encryptedData = CryptoHelper.encryptData({ email, password });
        const response = await fetch(`${BASE_URL}/api/auth/login`, {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedData }),
        });

        if (!response.ok) {
            throw new Error('Authentication error');
        }

        const responseData = await response.json();
        if (responseData) {
            const decryptedResponse = CryptoHelper.decryptData(responseData.data);
            return JSON.parse(await decryptedResponse);
        }
        throw new Error('Invalid response format');
    } catch (error) {
        throw normalizeToApiError(error);
    }
}



export async function logout(token: string, updateToken: (newToken: string) => void): Promise<any> {
    try {
        const response = await interceptorFetch(`auth/logout`, token, updateToken, {
            method: "POST"
        });

        if (!response.ok) {
            throw new Error('Logout error');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        throw normalizeToApiError(error);
    }
}